function e(i){i.directive("grow",t=>{t.addEventListener("input",()=>{t.style.height="auto",t.style.height=`${t.scrollHeight}px`})})}var d=e;export{d as default};
